<template>
  <main class="registration">
    <header class="registration__header">
      <dr-vector
        v-if="!isEmailConfirmation"
        fill="gradient"
        src="@/assets/img/Logo.svg"
      />

      <dr-icon
        v-if="$store.getters.$_checkAuth && !isEmailConfirmation"
        @click.native="$router.push('/logout')"
        name="logout"
        fill="gradient"
        class="registration__logout clickable"
      />
    </header>

    <div class="registration__router-view">
      <transition :name="currentTransition" mode="out-in">
        <router-view
          v-if="loaded"
          @interval="formData.appointmentInterval = $event"
          @step-change="updateStepsForm($event)"
          :user.sync="user"
          :formData.sync="formData"
        />
      </transition>
    </div>
  </main>
</template>

<script>
export default {
  data () {
    return {
      currentStep: 0,
      loaded: false,
      formData: {
        name: 'dr rodrigo',
        price: null,
        weekdaysSelected: [],
        periodsSelected: {},
        appointmentInterval: null
      },
      user: null,
      currentTransition: 'fade_left'
    }
  },
  computed: {
    isEmailConfirmation () {
      return (this.$route.name === 'EmailConfirmation')
    }
  },
  created () {
    if (this.$store.getters.$_checkAuth != null) {
      this.$http.get(`/doctor/registration_status`, this.$store.getters.getAuthHeader).then(
        (res) => {
          let status = res.data
          if (status === 'Pré-cadastro') {
            this.$router.replace({name: 'RegisterPreRegistrationSuccess'})
            this.loaded = true
          } else {
            this.$http.get(`/doctor`, this.$store.getters.getAuthHeader).then(
              (res) => {
                if (!status) {
                  this.$router.replace({name: 'DoctorAgenda'})
                  return
                }
                this.formData.office = res.data.doctor_offices[0]
                this.user = res.data.user
                this.user.displayName = res.data.display_name
                this.user.crm = res.data.crm
                this.loaded = true
                if (status === 'Cadastro') {
                  this.$router.replace({name: 'RegisterRegistration'})
                } else {
                  let officeId = res.data.doctor_offices[0].id
                  if (status === 'Configuração de tempo medio') {
                    this.$router.push({path: '/register/' + officeId + '/doctor-office/agenda/appointment_interval'})
                  } else if (status === 'Configuração de agenda') {
                    this.$router.push({path: '/register/' + officeId + '/doctor-office/agenda/new/1'})
                  } else if (status === 'Finalizado') {
                    this.$router.push({name: 'DoctorAgenda'})
                  }
                }
              }
            )
          }
        }
      ).catch(
        (err) => {
          console.log(err)
          this.$router.replace({name: 'RegisterPreRegistration'})
        }
      )
    } else {
      if (this.$route.name === 'EmailConfirmation') {
        this.$router.replace({ name: 'EmailConfirmation' })
      } else {
        this.$router.replace({name: 'RegisterPreRegistration'})
      }

      this.loaded = true
    }
  },
  methods: {
    updateStepsForm (ev) {
      if (ev) {
        this.formData[ev[0]] = ev[1]
      }
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.currentTransition = to.meta.step > from.meta.step ? 'fade_left' : 'fade_right'
    next()
  }
}
</script>
